import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TreeSelect } from '@components';
import { setConectoresSelecionados } from '@ducks/conectoresFolgas';
import styled from 'styled-components';

const TreeSelectComponent = styled(TreeSelect)`
  width: 100% !important;
`;

export default function TreeConectores({ treeData }) {
  const dispatch = useDispatch();

  const treeValue = useSelector(({ conectoresFolgas }) => conectoresFolgas.get('conectoresSelecionados'));

  const onChange = (value) => {
    dispatch(setConectoresSelecionados(value));
  };

  const tProps = {
    treeData,
    value: treeValue,
    onChange,
    treeCheckable: true,
    placeholder: 'Selecione os conectores',
  };

  return <TreeSelectComponent {...tProps} />;
}
